import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, Heart, Star } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';
import { useLang, TX } from '../../context/LangContext';
import { toast } from 'react-toastify';
import './ProductCard.css';

const BADGE_CONFIG = {
  bestseller:{ label:'🏆 Bestseller', cls:'badge-gold' }, new:{ label:'✨ New', cls:'badge-green' },
  certified:{ label:'✅ Certified', cls:'badge-green' }, festival:{ label:'🎉 Festival', cls:'badge-maroon' },
  energized:{ label:'🔮 Energized', cls:'badge-maroon' }, pure:{ label:'💧 Pure', cls:'badge-green' },
  rare:{ label:'💎 Rare', cls:'badge-gold' }, handmade:{ label:'🖐️ Handmade', cls:'badge-maroon' },
  organic:{ label:'🌿 Organic', cls:'badge-green' },
};

export default function ProductCard({ product }) {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const { user, isAuthenticated, toggleWishlist } = useAuth();
  const { t } = useLang();

  const effectivePrice = product.effectivePrice || (product.discount > 0 ? Math.round(product.price * (1 - product.discount / 100)) : product.price);
  const isWishlisted = user?.wishlist?.includes?.(product._id);
  const badge = product.badge && BADGE_CONFIG[product.badge];

  const handleWishlist = async (e) => {
    e.stopPropagation();
    if (!isAuthenticated) { navigate('/login'); return; }
    await toggleWishlist(product._id);
  };

  const handleAddToCart = (e) => {
    e.stopPropagation();
    if (product.stock === 0) return;
    addToCart(product);
  };

  return (
    <div className="product-card" onClick={() => navigate(`/product/${product.slug}`)}>
      <div className="product-card-img">
        {product.images?.[0]?.url ? <img src={product.images[0].url} alt={product.nameEn} loading="lazy" /> : <span className="product-card-emoji">🛕</span>}
        {product.discount > 0 && <div className="product-discount-badge">-{product.discount}%</div>}
        {badge && <div className={`product-badge badge ${badge.cls}`}>{badge.label}</div>}
        <button className={`product-wishlist${isWishlisted ? ' active' : ''}`} onClick={handleWishlist} title="Wishlist">
          <Heart size={14} fill={isWishlisted ? 'currentColor' : 'none'} />
        </button>
        {product.isAyodhyaAuthentic && <div className="authentic-seal">🛕 Ayodhya</div>}
      </div>
      <div className="product-card-body">
        <p className="product-name-hi">{product.nameHi}</p>
        <p className="product-name-en">{product.nameEn}</p>
        {product.rating > 0 && (
          <div className="product-rating">
            <Star size={11} fill="currentColor" className="star-icon" />
            <span>{product.rating.toFixed(1)}</span>
            <span className="review-count">({product.numReviews})</span>
          </div>
        )}
        <div className="product-price-row">
          <span className="product-price">₹{effectivePrice.toLocaleString('en-IN')}</span>
          {product.discount > 0 && <span className="product-price-orig">₹{product.price.toLocaleString('en-IN')}</span>}
        </div>
        <button
          className={`product-cart-btn${product.stock === 0 ? ' disabled' : ''}`}
          onClick={handleAddToCart}
          disabled={product.stock === 0}
        >
          {product.stock === 0 ? t(TX.outOfStock) : <><ShoppingCart size={13} /> {t(TX.addToCart)}</>}
        </button>
      </div>
    </div>
  );
}
